<template>
<div class="content-body tenant-settings">
    <div class="">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
            <el-form-item label="工厂:">
                <el-input size="small" v-model="dataForm.werks" placeholder="工厂" clearable @blur="queryData()"></el-input>
            </el-form-item>
            <el-form-item label="物料:">
                <el-input size="small" v-model="dataForm.matnr" placeholder="物料" clearable @blur="queryData()"></el-input>
            </el-form-item>
            <el-form-item label="库存地点:">
                <el-input size="small" v-model="dataForm.lgort" placeholder="库存地点" clearable @blur="queryData()"></el-input>
            </el-form-item>
            <el-form-item class="fr">
                <el-button size="small" @click="queryData()" icon="el-icon-search">
                    查询
                </el-button>
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :data="dataList" row-key="id" size="mini" bProject style="width: 100%;" :row-class-name="tableRowClassName" :default-expand-all="false" :header-cell-style="{background:'#f5f5f5'}" border :height="tableHeight">
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="werks" header-align="center" align="center" label="工厂" >
                </el-table-column>
                <el-table-column prop="lgort" header-align="center" align="center" label="库存地点">
                </el-table-column>
                <el-table-column prop="matnr" header-align="center" align="center" label="物料">
                </el-table-column>
                <el-table-column prop="lifnr" header-align="center" align="center" label="供应商">
                </el-table-column>
                <el-table-column prop="name1" header-align="center" align="center" label="工厂名称" width="250">
                </el-table-column>
                <el-table-column prop="lgobe" header-align="center" align="center" label="库存地点描述" width="250">
                </el-table-column>
                <el-table-column prop="maktx" header-align="center" align="center" label="物料描述" width="130">
                </el-table-column>
                <el-table-column prop="zname1" header-align="center" align="center" label="供应商名称" width="250">
                </el-table-column>
                <el-table-column prop="groes" header-align="center" align="center" label="规格">
                </el-table-column>
                <el-table-column prop="meins" header-align="center" align="center" label="基本单位">
                </el-table-column>
                <el-table-column prop="zqckc" header-align="center" align="center" label="期初库存">
                </el-table-column>
                <el-table-column prop="zrksl" header-align="center" align="center" label="入库数量">
                </el-table-column>
                <el-table-column prop="zcksl" header-align="center" align="center" label="出库数量">
                </el-table-column>
                <el-table-column prop="zqmjc" header-align="center" align="center" label="期末结存">
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20,50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
    </div>
</div>
</template>

<script>
import {
    getSapStoreTbl
} from '@/controller/sap'
import moment from 'moment'
// require('@/mock/mockContract');
export default {
    data() {
        return {
            documentClientHeight: document.documentElement['clientHeight'] - 250,
            dataForm: {
                lgobe: '',
                lgort: '',
                matnr: '',
                werks: '',
            },
            dataList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
        }
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 220
            }
        }
    },
    activated() {
        this.getDataList()
    },
    methods: {
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (date == undefined) {
                return ''
            }
            if (!date) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD")
        },
        queryData(){
            this.pageIndex = 1;
            this.getDataList()
        },
        tableRowClassName({row, rowIndex}) {
            var arrays = ["5601","5703"]
            var index = arrays.indexOf(row.lgort)
            if (index != -1) {
                return 'warning-row';
            } 
            return '';
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            getSapStoreTbl({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                'lgort': this.dataForm.lgort,
                'matnr': this.dataForm.matnr,
                'lifnr': this.dataForm.lifnr,
                'werks': this.dataForm.werks,
            }).then(data => {
                console.log(data, 'data')
                if (data && data.code === '00') {
                    this.dataList = data.body.records
                    this.totalPage = data.body.total
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
    }
}
</script>
<style>
  .el-table .warning-row {
    background: #FACD91;
  }

  .el-table .success-row {
    background: #FFFF80;
  }
  .el-table .succ-row {
    background: rgb(6, 245, 6);;
  }
</style>
<style lang="scss" scoped>
.button-danger {
    color: #F56C6C
}

.text-danger {
    color: #F56C6C
}

.text-success {
    color: #67C23A
}

.text-waming {
    color: #E6A23C;
}

.text-info {
    color: #909399;
}

.fr {
    float: right;
}
</style>
